import { Component, Input, OnInit } from '@angular/core'
import { AlertController, ModalController } from '@ionic/angular/standalone'
import { Observable, Subscription } from 'rxjs'
import { Transaction } from 'src/app/models/transactions'
import { OfflineTransactionsService } from 'src/app/services/offline-transactions.service'

@Component({
  selector: 'app-transactionlog',
  templateUrl: './transactionlog.page.html',
  styleUrls: ['./transactionlog.page.scss'],
  standalone: false,
})
export class TransactionlogPage implements OnInit {
  private sub: Subscription[] = []
  transactions$: Observable<Transaction[]>
  @Input() view: 'data' | 'images' = 'data'

  constructor(
    private modalController: ModalController,
    public alertController: AlertController,
    private offlineTransactionsService: OfflineTransactionsService
  ) {}

  ngOnInit() {
    console.warn('TransactionlogPage')

    this.transactions$ = this.offlineTransactionsService.getOfflineTransactions(this.view)
  }

  dismiss() {
    this.modalController.dismiss()
  }
  clearAll() {
    this.offlineTransactionsService.clearAll()
  }
  processImage(transaction: Transaction) {
    if (transaction.url.includes('files')) {
      this.offlineTransactionsService.processOfflineImage(transaction)
    } else {
      // For data transactions, mark as unprocessed and trigger sync
      transaction.processed = false
      transaction.error = ''
      this.offlineTransactionsService.processOfflineTransactions(true)
    }
  }
  async deleteImage(transaction: Transaction) {
    const alert = await this.alertController.create({
      header: 'Delete!',
      message: 'Please confirm deletion',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {},
        },
        {
          text: 'Okay',
          handler: () => {
            if (transaction.url.includes('files')) {
              this.offlineTransactionsService.deleteImage(transaction)
            } else {
              // For data transactions, mark as processed to skip it
              transaction.processed = true
              this.offlineTransactionsService.deleteTransaction(transaction)
            }
          },
        },
      ],
    })

    await alert.present()
  }
}
